import { useRef, useState } from 'react'
import { KeepAlive } from 'react-activation'
import { SActionBtn, SLowcodeList, STableActions, SListTabs } from 'shj-components'
import {
  quotationProposalPage,
  getQuotationFlowEnum,
} from '@/services/order'
import { httpOrgList } from '@/services/homeService'
import { config } from './config'
import ProcessRecord from '@/components/ProcessRecord'

const processStatusList = [{
  label: '全部',
  key: 'all',
}, {
  label: '待我审核',
  key: 'pending',
}, {
  label: '我已审核',
  key: 'processed'
}]

const processStatusType = {
  complete: '#70a310',
  reject: 'red',
  terminate: 'gray',
  waitAudit: '#0064ff',
}

export default function ImageProcessList() {
  const listRef = useRef<any>(null)
  const statusRef = useRef<any>('all')

  const [openProcessRecordModal, setOpenProcessRecordModal] = useState(false);
  const [recordInfo, setRecordInfo] = useState<any>({})

  const fetchList = async values => {
    try {
      const { current, pageSize, ...rest } = values
      const data: any = await quotationProposalPage({
        params: { pageId: current, pageSize },
        data: {...rest.query, model: statusRef?.current},
      })
      console.log(data)
      return { records: data.list, total: data.count, success: true }
    } catch (err) {
      return { success: false };
    }
  }

  const clickToView = (record, auth) => {
    if (record.dealMode === 'DIRECT') {
      // 直接付款详情
      window.open(`/order/list/details/direct-index/${record.id}`)
    } else {
      // 签约付款详情
      window.open(`/order/list/details/${record.id}`)
    }
  }

  const getOptions = async () => {
    const companyList = await httpOrgList({ status: '' })
    const processStatusEnum = await getQuotationFlowEnum()
    return Promise.resolve({ companyList, processStatusEnum })
  }

  const handleChangeTab = (tab: any) => {
    statusRef.current = tab;
    listRef?.current?.resetPagination()
    listRef?.current?.reload();
  }

  const jumpToDetail = (record: any) => {
    window.open(`/order/processDetail/${record?.processInstanceId}`)
  }

  const extensions = {
    request: { fetchList, getOptions },
    events: {
      clickToView,
    },
    customRender: {
      statusRender(text: any, record: any) {
        return <div style={{ color: processStatusType?.[record?.processState] || '#000', display: 'flex', alignItems: 'center' }}>
          <div style={{ width: '8px', height: '8px', backgroundColor: processStatusType?.[record?.processState] || '#000', borderRadius: '50%', marginRight: '4px'}}></div>
          { text }
          </div>
      },
      actionRender(_, record: Record<string, any>) {
        return (
          <STableActions>
            <SActionBtn
              onClick={() => jumpToDetail(record)}
              style={{ height: '20px' }}
            >详情</SActionBtn>
            <SActionBtn
              onClick={() => {
                setOpenProcessRecordModal(true)
                setRecordInfo(record)
              }}
              style={{ height: '20px' }}
            >审核记录</SActionBtn>
          </STableActions>
        )
      },
    },
  }
  return (
    <KeepAlive name={location.pathname}>
      <div>
        <SListTabs defaultActiveKey={''} items={processStatusList} hideExtra={false} onChange={handleChangeTab} />
        <SLowcodeList ref={listRef} searchMode="group" config={config} {...extensions} />
        {
          openProcessRecordModal ? <ProcessRecord
            title='审核记录'
            open={openProcessRecordModal}
            setOpen={setOpenProcessRecordModal}
            quoteBudgetId={recordInfo?.budgetId}
          /> : null
        }
      </div>
    </KeepAlive>
  )
}
